import {
    Grid, Typography, Box, 
} from "@mui/material";
import { useState, useEffect } from "react";
import CircularProgress from '@mui/material/CircularProgress';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import * as CONSTANTS from "../../constants"

import { submit_update_wotageishi_request } from "../../services/topic_request";

const getConfirmationFormByStatusCode = (statusCode, lang) => {
    const iconStyle = {
        transition: 'transform 0.5s, opacity 0.5s',
        display: 'inline-block',
    };
    return (
        <Box
            sx={{
                position: 'relative',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                textAlign: 'center',
                padding: 2,
            }}
        >
            {statusCode === 0 && (
                <CircularProgress size={40} color="primary" style={iconStyle} />
            )}
            {statusCode === 200 && (
                <CheckCircleIcon
                style={{
                    ...iconStyle,
                    transform: 'scale(1.2)',
                }}
                color="success"
                />
            )}
            {statusCode === 400 && (
                <CancelIcon
                    style={{
                        ...iconStyle,
                        transform: 'scale(1.2)',
                    }}
                    color="error"
                />
            )}
            <Typography variant="h6" sx={{ marginTop: 1 }}>
                {statusCode === 0
                ? CONSTANTS.REQUEST_TOPIC.CONFIRMATION_MESSAGE.UPLOADING[lang]
                : statusCode === 200
                ? CONSTANTS.REQUEST_TOPIC.CONFIRMATION_MESSAGE.UPLOAD_SUCCESSFUL[lang]
                : statusCode === 400 || statusCode === 500
                ? CONSTANTS.REQUEST_TOPIC.CONFIRMATION_MESSAGE.UPLOAD_FAILED[lang]
                : ''}
            </Typography>
        </Box>
    );
}


const ConfirmationForm = ({formik, lang}) => {

    useEffect(() => { window.scrollTo(0, 0) }, []);

    const [msg, setMsg] = useState('');
    const [statusCode, setStatusCode] = useState(0);
    const [sent, setSent] = useState(false);
    
    // send an request to server to submit and render sending request.
    const submitData = async (data) => {
        const [status, result] = await submit_update_wotageishi_request(data);
        setStatusCode(status);
        setMsg(result.msg);
    };

    const data = {
        requester: '',
        requester_remarks: '',
        name: {
            en: formik.values.name_en,
            jp: formik.values.name_jp,
            tc: formik.values.name_tc,
            sc: formik.values.name_sc,
        },
        default_name: formik.values.default_name,
        active_regions: formik.values.active_regions,
        markings: formik.values.markings,
        organization_uids: formik.values.organization_uids,
        original_wazaren_uids: formik.values.original_wazaren_uids,
        start_date: {
            value: formik.values.start_date? formik.values.start_date.toISOString(): '',
            has_year: formik.values.has_year,
            has_month: formik.values.has_month,
            has_day: formik.values.has_day,
        },
        date_last_updated: new Date(),
        official_account: {
            youtube: formik.values.official_account_youtube,
            bilibili: formik.values.official_account_bilibili,
            x: formik.values.official_account_x,
        },
        wotageishi_uid: formik.values.wotageishi_uid,
    }
    if (!sent) {
        setSent(true);
        submitData(data);
    }

    return (
        <Grid
            container
            spacing={2}
        >
            {getConfirmationFormByStatusCode(statusCode, lang)}
        </Grid>
    )
}

export default ConfirmationForm;